<template>
  <div class="columns">
    <div class="column is-three-quarters ">
      <admin-section-header icon="arrow-up" :title="$t('Notificaciones')" />
      <SectionUnderDevelopment text="No tiene notificaciones"/>
    </div>
    <div class="column is-one-quarter twitter">
      <TwitterFeed profile="bopinion" />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import TwitterFeed from '@/components/admin/dasboard/TwitterFeed.vue'
import SectionUnderDevelopment from '@/components/common/SectionUnderDevelopment.vue'
export default {
  components: { TwitterFeed, AdminSectionHeader, SectionUnderDevelopment },
  mounted() {},
  data() {
    return {}
  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequests'])
  }
}
</script>

<style scoped>
.columns {
  margin-top: 0;
  overflow: hidden;
}
.column.twitter,
.solicitudes-table {
  overflow: scroll;
}
</style>
